import React from 'react'
import PropTypes from 'prop-types'

const RightArrowIcon = ({ customClassName, width, height, fill, }) =>
  (<svg
    className={customClassName}
    width={width}
    height={height}
    aria-labelledby="Left Arrow"
    viewBox="0 0 32.635 32.635"
  >
    <title id="right-arrow-icon">Right Arrow</title>
    <g>
      <path
        fill={fill}
        d="M32.135,16.817H0.5c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h31.635c0.276,0,0.5,0.224,0.5,0.5
    		S32.411,16.817,32.135,16.817z"
      />
      <path
        fill={fill}
        d="M19.598,29.353c-0.128,0-0.256-0.049-0.354-0.146c-0.195-0.195-0.195-0.512,0-0.707l12.184-12.184L19.244,4.136
    		c-0.195-0.195-0.195-0.512,0-0.707s0.512-0.195,0.707,0l12.537,12.533c0.094,0.094,0.146,0.221,0.146,0.354
    		s-0.053,0.26-0.146,0.354L19.951,29.206C19.854,29.304,19.726,29.353,19.598,29.353z"
      />
    </g>
  </svg>)

RightArrowIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  customClassName: PropTypes.string,
}

RightArrowIcon.defaultProps = {
  width: 20,
  height: undefined,
  fill: 'blue',
  customClassName: '',
}

export default RightArrowIcon



// WEBPACK FOOTER //
// ./src/components/icons/RightArrow.js